// O backend responde HTTP 200 sempre e põe o status real no corpo (`r.status`).
export const HTTP_OK = 200
